import axios from "axios";
import { baseURL } from "../config";
import { ElMessage } from "element-plus";
import { isMobileFlag } from "@/config";
import router from "@/router";

// 创建 axios 请求实例
const serviceAxios = axios.create({
  baseURL: baseURL, // 基础请求地址
  timeout: 10000, // 请求超时设置
  withCredentials: false, // 跨域请求是否需要携带 cookie
});

// 创建请求拦截
serviceAxios.interceptors.request.use(
  (config) => {
    config.headers["Authorization"] = window.localStorage.getItem("token")
      ? "Bearer " + window.localStorage.getItem("token")
      : "";
    if (!config.headers["content-type"]) {
      // 如果没有设置请求头
      if (config.method === "post") {
        config.headers["content-type"] = "application/json"; // post 请求
      }
    }

    // 设置请求头
    // config.headers["content-type"] = "application/json";
    // if (!config.headers["content-type"]) {
    //   // 如果没有设置请求头
    //   if (config.method === "post") {
    //     config.headers["content-type"] = "application/x-www-form-urlencoded"; // post 请求
    //   } else {
    //     config.headers["content-type"] = "application/json"; // 默认类型
    //   }
    // }
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

// 创建响应拦截
serviceAxios.interceptors.response.use(
  (res) => {
    let data = res.data;
    // 处理自己的业务逻辑，比如判断 token 是否过期等等
    // 代码块
    if (res.data.code === 401) {
      setTimeout(() => {
        ElMessage.error(
          "You have not logged in, or your login has timed out. Please log in first！"
        );
      }, 1000);
      if (isMobileFlag) {
        location.href = "http://www.shenniudata.com:9911/mobile/login";
      } else {
        router.push("/login");
      }
    }
    return data;
  },
  (error) => {
    let message = "";
    if (error && error.response) {
      switch (error.response.status) {
        case 302:
          message = "The interface has been redirected！";
          break;
        case 400:
          message = "parameter is incorrect！";
          break;
        case 401:
          message =
            "You have not logged in, or your login has timed out. Please log in first！";
          break;
        case 403:
          message = "You do not have permission to operate！";
          break;
        case 404:
          message = `Request address error: ${error.response.config.url}`;
          break;
        case 408:
          message = "request timeout！";
          break;
        case 409:
          message = "The same data already exists in the system！";
          break;
        case 500:
          message = "Internal server error！";
          break;
        case 501:
          message = "Service not implemented！";
          break;
        case 502:
          message = "Bad Gateway ！";
          break;
        case 503:
          message = "Service unavailable！";
          break;
        case 504:
          message =
            "The service is temporarily inaccessible. Please try again later！";
          break;
        case 505:
          message = "HTTP Version not supported！";
          break;
        default:
          message = "Abnormal issue, please contact the administrator！";
          break;
      }
    }
    return Promise.reject(message);
  }
);
export default serviceAxios;
